export const base_url = "templates/react";
